var _circle, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransferIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.93591,
    cy: 6.4187,
    r: 5.49133,
    fill: "#EA345F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_626_4485",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 2,
    width: 10,
    height: 10
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.177,
    y: 2.02612,
    width: 8.99423,
    height: 8.99423,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_626_4485)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.19354 7.82493L7.16533 6.72432C7.04372 6.59414 6.87788 6.52313 6.71204 6.52313C6.53514 6.52313 6.38036 6.59414 6.25874 6.72432C6.13712 6.8545 6.07079 7.03202 6.07079 7.20953C6.07079 7.36338 6.11501 7.5054 6.1924 7.62374H3.6274C3.27361 7.62374 2.9751 7.93144 2.9751 8.32198C2.9751 8.70068 3.26255 9.02021 3.6274 9.02021H6.18135C5.99339 9.29241 6.01551 9.67111 6.24768 9.91964C6.3693 10.0498 6.53514 10.1208 6.70098 10.1208C6.87788 10.1208 7.03266 10.0498 7.15428 9.91964L8.18249 8.81903C8.3041 8.68885 8.37044 8.52316 8.37044 8.33381C8.3815 8.13263 8.31516 7.95511 8.19354 7.82493Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.1546 5.22134L4.18281 6.32195C4.30443 6.45213 4.47027 6.52313 4.63611 6.52313C4.813 6.52313 4.96779 6.45213 5.08941 6.32195C5.21102 6.19177 5.27736 6.01425 5.27736 5.83673C5.27736 5.68288 5.23313 5.54087 5.15574 5.42252H7.72074C8.07453 5.42252 8.37305 5.11483 8.37305 4.72429C8.37305 4.34558 8.08559 4.02605 7.72074 4.02605H5.1668C5.35475 3.75386 5.33264 3.37515 5.10046 3.12663C4.97885 2.99645 4.813 2.92544 4.64716 2.92544C4.47027 2.92544 4.31548 2.99645 4.19387 3.12663L3.16566 4.22724C3.04404 4.35742 2.9777 4.5231 2.9777 4.71245C2.96665 4.91364 3.03298 5.09116 3.1546 5.22134Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferIcon);
export default __webpack_public_path__ + "static/media/transferIcon.e7575324d226037c9f8865daa7f87491.svg";
export { ForwardRef as ReactComponent };